// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bem_a bhs_qn bhs_qo bhs_ua bhs_cy bhs_ty bhs_go bhs_ka"};